import { render, staticRenderFns } from "./CancelReason.vue?vue&type=template&id=3b8b9ac2&"
import script from "./CancelReason.vue?vue&type=script&lang=js&"
export * from "./CancelReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CancelReason.vue"
export default component.exports